import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import s from './SceneInfoModal.module.scss'

import { getIconByMetaverse } from 'constants/MetaverseIcons'

import { useFetch } from 'hooks/useFetch'

import { scenesApi } from 'api/scenes-api'

import { ImageIcon } from 'assets/icons/ImageIcon'

import { CustomButton } from 'components/UI/CustomButton/CustomButton'
import { ModalFullScreen } from 'components/UI/ModalFullScreen/ModalFullScreen'

export const SceneInfoModal = () => {
  const [searchParams] = useSearchParams()

  const { id } = useParams()
  const navigate = useNavigate()

  const { data: scene, loading } = useFetch({
    getData: () => scenesApi.getOne(+(id || 0)),
  })

  const onCloseModal = () => {
    navigate(`../?${searchParams}`)
  }

  const openEditForm = () => {
    navigate(`../edit/${id}/?${searchParams}`)
  }

  return (
    <ModalFullScreen onHide={onCloseModal} loading={loading} className={s.modalWrapper}>
      <div></div>
      <div className={s.wrapper}>
        <div className={s.imageWrapper}>
          <img src={getIconByMetaverse(scene?.metaverse)} alt="" className={s.metaLogo} />
          {scene?.preview_file ? (
            <img src={scene?.preview_file} alt="Preview" className={s.scenePreview} />
          ) : (
            <div className={s.previewFallbackWrapper}>
              <ImageIcon className={s.previewFallback} />
              <p className={s.previewFallbackText}>No preview image</p>
            </div>
          )}
        </div>
        <div className={s.infoWrapper}>
          <div className={s.row}>
            <div className={s.col}>
              <h3 className={s.header}>{scene?.name}</h3>
            </div>
          </div>
          <p className={s.description}>{scene?.description}</p>
          <div className={s.coords}>{scene?.coords}</div>
        </div>
      </div>
      <div className={s.buttonsWrapper}>
        <CustomButton variant="secondary" onClick={openEditForm} size="240" className={s.editBtn}>
          Edit
        </CustomButton>
        <CustomButton variant="outlined" onClick={onCloseModal} size="152">
          Close
        </CustomButton>
      </div>
    </ModalFullScreen>
  )
}
